import { useUncontrolled } from "@vnmfify/hooks";
import { View } from "@vnxjs/components";
import classNames from "classnames";
import * as _ from "lodash";
import * as React from "react";
import { prefixClassname } from "../styles";
import NativeTextarea from "./native-textarea";
import { getStringLength } from "./textarea.shared";
function Textarea(props) {
    const { className, placeholderClass, value: valueProp, readonly, disabled, limit, maxlength: maxlengthProp, onInput, onChange, ...restProps } = props;
    const maxlength = _.isNumber(limit) ? limit : maxlengthProp;
    const { value, setValue } = useUncontrolled({ value: valueProp });
    return (React.createElement(View, { className: prefixClassname("textarea__wrapper") },
        React.createElement(NativeTextarea, { className: classNames(prefixClassname("textarea"), {
                [prefixClassname("textarea--readonly")]: readonly,
            }, className), placeholderClass: classNames(prefixClassname("textarea__placeholder"), {
                [prefixClassname("textarea__placeholder--readonly")]: readonly,
            }, placeholderClass), disabled: readonly || disabled, readonly: readonly, maxlength: maxlength, value: value, onInput: (e) => {
                setValue(e.detail.value);
                onInput?.(e);
                onChange?.(e);
            }, ...restProps }),
        limit && (React.createElement(View, { className: prefixClassname("textarea__limit") },
            getStringLength(value),
            "/",
            maxlength))));
}
export default Textarea;
